import { ArchiveBoxIcon, ArrowDownOnSquareIcon, BoltIcon, CheckBadgeIcon, ClockIcon, PhoneArrowUpRightIcon, StopIcon } from "@heroicons/react/24/solid";
import { ConditionalRuleMode } from "./Conditional";
import { EndAction } from "./End";
import { AssistantNodeAction, NodeType } from "./NodeType";
import { RiWhatsappFill } from "react-icons/ri";
import { PiArrowsSplitBold } from "react-icons/pi";
import { AiFillApi } from "react-icons/ai";
import { TbWebhook } from "react-icons/tb";

export const NodeUIRegistry = {
  [NodeType.WEBHOOK_TRIGGER]: {
    default: {
      icon: BoltIcon,
      label: "Webhook Trigger",
      color: "amber"
    },
  },
  [NodeType.ASSISTANT]: {
    [AssistantNodeAction.VOICE_CALL]: {
        icon: PhoneArrowUpRightIcon,
        label: "Call",
        color: "amber"
    },
    [AssistantNodeAction.WHATSAPP_MESSAGE]: {
        icon: RiWhatsappFill,
        label: "Whatsapp",
        color: "emerald"
    },
  },
  [NodeType.CONDITIONAL]: {
    [ConditionalRuleMode.RULES]: {
        icon: PiArrowsSplitBold,
        label: "Condition - Rules",
        color: "indigo"
    },
  },
  [NodeType.EXTERNAL_API]: {
    default: {
        icon: AiFillApi,
        label: "API",
        color: "pink"
    },
  },
  [NodeType.WAIT_FOR_CALLBACK]: {
    default: {
        icon: ArrowDownOnSquareIcon,
        label: "Callback",
        color: "yellow"
    },
  },
  [NodeType.DELAY]: {
    default: {
        icon: ClockIcon,
        label: "Delay",
        color: "amber"
    },
  },
  [NodeType.END]: {
    [EndAction.NONE]: {
        icon: StopIcon,
        label: "End",
        color: "rose"
    },
    [EndAction.ARCHIVE_CONVERSATION]: {
        icon: ArchiveBoxIcon,
        label: "End - Archive",
        color: "rose"
    },
    [EndAction.WEBHOOK_NOTIFICATION]: {
      icon: TbWebhook,
      label: "End - Webhook",
      color: "rose"
    }
  },
};
